import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/pembukaan-rekening",
    url_path: "/laporan/pembukaan-rekening",
  },
];
